/**
 * 薬剤名の和中翻訳マップ
 * 医師（日本人）が利用する日文名称をキーとし、中文ユーザー向けの対訳を値とする
 */
export const drugTranslations: Record<string, string> = {
  // 肥満治療 (Obesity)
  'マンジャロ': '替尔泊肽注射液 (Mounjaro)',
  'リベルサス': '口服司美格鲁肽 (Rybelsus)',
  'フォシーガ': '达格列净片 (Forxiga)',
  'メトホルミン': '二甲双胍 (Metformin)',

  // スキンケア (Skincare)
  'トラネキサム酸': '氨甲环酸 (Tranexamic Acid)',
  'ユベラ': '维生素 E (Juvela)',
  'シナール': '希那尔 (Cinal)',
  'Lシステイン': 'L-半胱氨酸 (L-Cysteine)',
  '十味敗毒湯': '十味败毒汤 (Jumihaidokuto)',
  '3種セット(美容内服)': '美容内服3种套装',
  '3種セット(肌ケアライト)': '3种套餐 (护肤轻盈款)',
  '4種セット(肌ケアベーシック)': '4种套餐 (护肤基础款)',

  // AGA
  'フィナステリド': '非那雄胺 (Finasteride)',
  'デュタステリド': '度他雄胺 (Dutasteride)',

  // ED
  'タダラフィル': '他达拉非 (Tadalafil)',
  'シアリス': '希爱力 (Cialis)',
  'シルデナフィル': '西地那非 (Sildenafil)',
  'バルデナフィル': '伐地那非 (Vardenafil)',
  '（连续投与）': '（连续服用）',
  '（1錠）': '（1片）',

  // ピル (Pill)
  'トリキュラー': '特洁乐 (Triquilar)',
  'マーベロン': '妈富隆 (Marvelon)',
  'プラノバール': '普拉诺芭尔 (Planovar)',
  'アフターピル': '紧急避孕药 (Emergency Contraceptive)',

  // AGA サポート薬 / 女性
  'ミノキシジル': '米诺地尔 (Minoxidil)',
  'スピロノラクトン': '螺内酯 (Spironolactone)',
  'サプリメント': '营养补剂 (Supplement)',
};

/**
 * 薬剤名を現在の言語に合わせて翻訳・整形する
 * 日文版はそのまま、中文版は翻訳後の名称のみにする
 */
export function translateMedicineName(name: string, lang: string): string {
  if (!lang.toLowerCase().startsWith('zh')) {
    return name;
  }

  // 完全一致チェック
  if (drugTranslations[name]) {
    return drugTranslations[name];
  }

  // 部分一致（前方一致）チェック
  // 例: "マンジャロ 2.5mg" -> "替尔泊肽注射液 2.5mg (Mounjaro)"
  for (const [jp, zh] of Object.entries(drugTranslations)) {
    if (name.startsWith(jp)) {
      // 単位や規格の部分を抽出
      const suffix = name.slice(jp.length).trim();
      // "（1錠）" などの単位も翻訳対象にあれば置换
      let translatedSuffix = suffix;
      for (const [sJp, sZh] of Object.entries(drugTranslations)) {
        if (sJp.startsWith('（') && translatedSuffix.includes(sJp)) {
          translatedSuffix = translatedSuffix.replace(sJp, sZh);
        }
      }
      
      // DB名の規格部分に、翻訳先(zh)と同じブランド括弧が既に含まれる場合は二重表示を避けて除去する。
      // 例: "マンジャロ 2.5mg (Mounjaro)" の suffix="2.5mg (Mounjaro)" と zh="…(Mounjaro)" で "(Mounjaro)" が重複するのを防ぐ。
      const zhBrand = zh.match(/\([^)]*\)/);
      if (zhBrand && translatedSuffix.includes(zhBrand[0])) {
        translatedSuffix = translatedSuffix.replace(zhBrand[0], '').replace(/\s{2,}/g, ' ').trim();
      }

      const zhBase = zh.includes('(') 
        ? zh.replace(' (', ` ${translatedSuffix} (` ) // "内服 (Brand)" -> "内服 规格 (Brand)"
        : `${zh} ${translatedSuffix}`;
      
      // 規格が空になった場合などに生じる余分な連続スペースを1つに詰める
      return zhBase.replace(/\s{2,}/g, ' ').trim();
    }
  }

  return name;
}
